module.exports = __webpack_public_path__ + "static/media/placas black.4cfc11b4.svg";